import { makeAuthenticatedServiceRequest, makePublicServiceRequest } from './servicesClient';
import { delay } from '../util/promise';
import { makeHttps } from '../util/url';

const ipaUrl = 'https://ipa.documents.cimpress.io/v2';

const CARTOON_POLL_DELAY = 100;
const CRISPIFY_POLL_DELAY = 500;

function requestJobCheck(jobId) {
    const url = `${ipaUrl}/status/${jobId}`;
    return makePublicServiceRequest({ url });
}

function waitForJob(jobId, pollingDelay) {
    return requestJobCheck(jobId)
        .then((response) => {
            if (response.data.jobStatus === 'Pending') {
                return delay(pollingDelay).then(() => waitForJob(jobId, pollingDelay));
            } else if (response.data.jobStatus === 'Failed') {
                throw Error(response.data.exceptionMessage);
            }
            return response;
        });
}

export function classifyCartoon({ imageUrl }) {
    const data = {
        imageUrl,
    };
    const url = `${ipaUrl}/process/cartoon`;

    return makeAuthenticatedServiceRequest({ url, method: 'post', data })
        .catch((error) => { throw Error(`Cartoon classification Failed! ${error.data.statusText}`); })
        .then(response => waitForJob(response.data.jobId, CARTOON_POLL_DELAY))
        .then(response => response.data.cartoonClassification);
}

/**
 * Make a request to crispify for an imageUrl
 * @param {object} object
 * @param {string} object.imageUrl - the url that you want to run crispify services on
 * @param {string} object.texture - the texture amount that you want to pass to the service
 * @param {string} object.applySuperResolutionToAlpha - boolean that doubles resolution
 */
export function crispify({ imageUrl, texture = 0, superResolution = true }) {
    if (!imageUrl || (imageUrl && !imageUrl.match(/^http(s?):\/\//))) {
        return Promise.resolve('');
    }

    const data = {
        textureAmount: texture,
        applySuperResolutionToAlpha: superResolution,
        imageUrl,
    };
    const url = `${ipaUrl}/process/crispify`;

    return makeAuthenticatedServiceRequest({ url, method: 'post', data })
        .catch((error) => { throw Error(`Crispify Failed! ${error.data.statusText}`); })
        .then(response => waitForJob(response.data.jobId, CRISPIFY_POLL_DELAY))
        .then(response => makeHttps(response.data.resultImage));
}

/**
 * Check if we can use the crispify service on the filetype provided
 * @param {string} fileType
 */
export function canCrispify(fileType) {
    const cripifyEligibleFileTypes = ['image/jpeg', 'image/png', 'image/gif'];
    return cripifyEligibleFileTypes.includes(fileType);
}



// WEBPACK FOOTER //
// ./src/services/ipaClient.js